import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {
    CadastrarConjuntoCategoriaContabilComponent
} from './cadastrar-conjunto-categoria-contabil/cadastrar-conjunto-categoria-contabil.component';
import {ConjuntoCategoriaContabilComponent} from './conjunto-categoria-contabil.component';
import {AuthGuard} from '../../guards/auth.guard';
import {AcessoModuloResolver} from '../../guards/acesso-modulo.resolve';
import {Modulos} from '../../core/modulos';

const routes: Routes = [
    {
        path: 'conjuntos-categoria-contabil',
        component: ConjuntoCategoriaContabilComponent,
        canActivate: [AuthGuard],
        resolve: {perfilAcesso: AcessoModuloResolver},
        data: {modulo: Modulos.CONJUNTO_CATEGORIA_CONTABIL}
    },
    {
        path: 'conjuntos-categoria-contabil/cadastrar',
        component: CadastrarConjuntoCategoriaContabilComponent,
        canActivate: [AuthGuard],
        resolve: {perfilAcesso: AcessoModuloResolver},
        data: {modulo: Modulos.CONJUNTO_CATEGORIA_CONTABIL}
    },
    {
        path: 'conjuntos-categoria-contabil/cadastrar/:id',
        component: CadastrarConjuntoCategoriaContabilComponent,
        canActivate: [AuthGuard],
        resolve: {perfilAcesso: AcessoModuloResolver},
        data: {modulo: Modulos.CONJUNTO_CATEGORIA_CONTABIL}
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class ConjuntoCategoriaContabilRoutingModule {
}
